import store from '@core/store/store.js';

const isSafeInternalRedirect = redirect => (
    typeof redirect === 'string' &&
    redirect.startsWith('/') &&
    !redirect.startsWith('//')
);

const requiresNotAuthGuard = async (to, from, next) => {
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const _company_type = localStorage.getItem('type');
    const currentUser = localStorage.getItem('accessToken');

    if (!_company_type || !currentUser || to.name.includes('Register')) {
        next();
    } else {
        if (!requiresAuth && currentUser) {
            if (isSafeInternalRedirect(to.query.redirect)) {
                next(to.query.redirect);
                return;
            }
            if (_company_type === 'request') {
                const _company_id = localStorage.getItem('company_id');
                next({
                    name: 'ContractorProgress',
                    params: { requestsId: _company_id }
                });
            } else {
                next({ name: 'Main' });
            }
        } else {
            next();
        }
    }
};

const requiresAuthGurard = async (to, from, next) => {
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const _company_type = localStorage.getItem('type');
    const currentUser = localStorage.getItem('accessToken');

    if (requiresAuth && (!currentUser || !_company_type)) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
    } else {
        const company_id = localStorage.getItem('company_id');
        if (!company_id) {
            await store.dispatch('logout');
            localStorage.clear();
            next({ name: 'Login', query: { redirect: to.fullPath } });
        } else if (to.name.includes('Register')) {
            next();
        } else if (_company_type === 'request' && to.meta.dashboardType !== 'contractor') {
            next({
                name: 'ContractorProgress',
                params: {
                    'requestsId': company_id,
                    'projectid': 'latest'
                }
            });
        } else if (_company_type !== 'request' && to.meta.dashboardType === 'contractor') {
            next({ name: 'Main' });
        } else {
            next();
        }
    }
};

export {
    requiresAuthGurard,
    requiresNotAuthGuard,
};
